import React, { FC } from 'react';

import footerSnippet from './assets/footer.html.txt';

const Footer: FC = () => (
    <div
        data-testid="universal-footer"
        dangerouslySetInnerHTML={{
            __html: footerSnippet
        }}
    />
);

export default Footer;
